import {Component, OnDestroy, OnInit} from '@angular/core';
import {toggleLoading} from "../../../redux";
import {ICommunicationRequest, IDealTeam, IDealTeamMemberRequest} from "../../models";
import {AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators} from "@angular/forms";
import {Store} from "@ngrx/store";
import {DealService, DealTeamMembersService} from "../../services";
import {HttpErrorResponse} from "@angular/common/http";
import {UtilService} from "../../../shared/services";
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-communication',
  templateUrl: './communication.component.html',
  styleUrls: ['./communication.component.scss']
})
export class CommunicationComponent {

  today: Date | null;


  userForm = new FormGroup({
    callAgenda: new FormControl('', Validators.required),
    teamEmails: new FormControl('', [Validators.required, commaSeparatedEmailsValidator()]),
    callLength: new FormControl(30, Validators.required),
  });

  callTimeSelector : FormGroup = new FormGroup({
    callDate: new FormControl(undefined, Validators.required),
    callTimeHr: new FormControl(9, Validators.required),
    callTimeMin: new FormControl(0, Validators.required)
  })

  timeHrOptions = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
  timeMinOptions = [0, 15, 30, 45];

  sent = false;
  readonly MAX_LEN = 5;
  scheduleDateTimes: string[] = [];

  constructor(
    private store: Store,
    // private router: Router,
    private toastr: ToastrService,
    // private dealTeamMembersService: DealTeamMembersService,
    private dealService: DealService,
    public util: UtilService
  ) {

    this.today = new Date();
  }

  addSchedule() {
    if (this.scheduleDateTimes.length >= this.MAX_LEN) {
      this.toastr.error(`You can only add ${this.MAX_LEN} suggested times`);
      return;
    }

    let selectedDate = this.callTimeSelector.get('callDate')?.value as moment.Moment;
    const hr = parseInt(this.callTimeSelector.get('callTimeHr')?.value || '0');
    const min = parseInt(this.callTimeSelector.get('callTimeMin')?.value || '0');

    selectedDate?.hour(hr);
    selectedDate?.minute(min);
    selectedDate?.second(0);
    selectedDate?.millisecond(0);

    if (!!selectedDate)
      this.scheduleDateTimes.push(selectedDate.format("dddd MMM DD, YYYY hh:mm A") + ` (${Intl.DateTimeFormat().resolvedOptions().timeZone})`);
  }


  save() {
    let payload = <ICommunicationRequest> {
      suggestedDatesTimes: this.scheduleDateTimes.join(', '),
      teamEmails: this.userForm.get('teamEmails')?.value?.split(',') ?? [],
      callAgenda: this.userForm.get('callAgenda')?.value,
      callLength: this.userForm.get('callLength')?.value
    };

    this.store.dispatch(toggleLoading({loading: true}));
    this.dealService.investorCallRequest(payload).subscribe({
      next: (res: any) => {
        this.sent = true;
        this.scheduleDateTimes = [];
        this.userForm.reset();
        this.store.dispatch(toggleLoading({loading: false}));
        this.toastr.success("Communication Request Sent!", $localize`:@@companyName:Rondeivu`);
      }, error: (error: HttpErrorResponse) => {
        this.store.dispatch(toggleLoading({loading: false}));
        this.toastr.error("Unable to send communication request!", $localize`:@@companyName:Rondeivu`);
      }
    });
  }

  // /**
  //  * Gets the available deal teams
  //  */
  // private getDealTeams() {
  //   this.dealTeamMembersService.getDealTeams().subscribe({
  //     next: (dealTeams: IDealTeam[]) => {
  //       // console.log(JSON.stringify(dealTeams));
  //       dealTeams.forEach(team => {
  //         this.getDealTeamMembers(team.id);
  //       });
  //     }, error: (err: any) => {
  //       this.toastr.error("Unable to get deal teams!", $localize`:@@companyName:Rondeivu`);
  //     }
  //   });
  // }

  // /**
  //  * Gets the members of the deal team and adds them to the list
  //  * @param dealTeamId
  //  */
  // private getDealTeamMembers(dealTeamId: string) {
  //   this.dealTeamMembersService.getDealTeamMembers(dealTeamId).subscribe({
  //     next: (members: IDealTeamMemberRequest[]) => {
  //       // console.log(JSON.stringify(members));
  //       members.forEach(member => {
  //         // console.log(member.email);
  //         this.memberEmails.push(member.email);
  //       });
  //     }, error: (err: any) => {
  //       this.toastr.error("Unable to get deal team members!", $localize`:@@companyName:Rondeivu`);
  //     }
  //   });
  // }

}


export function commaSeparatedEmailsValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value: string = control.value;
 
    // Allow empty/null values — use Validators.required separately if needed
    if (!value || value.trim() === '') {
      return null;
    }
 
    const emailRegex = /^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$/;
 
    const emails = value
      .split(',')
      .map((email: string) => email.trim())
      .filter((email: string) => email.length > 0); // ignore empty tokens from trailing commas
 
    if (emails.length === 0) {
      return null;
    }
 
    const invalidEmails = emails.filter((email: string) => !emailRegex.test(email));
 
    if (invalidEmails.length > 0) {
      return {
        invalidEmails: {
          message: `The following ${invalidEmails.length === 1 ? 'address is' : 'addresses are'} invalid: ${invalidEmails.join(', ')}`,
          invalidList: invalidEmails,
        },
      };
    }
 
    return null;
  };
}
 